import { z } from 'zod';
import { phone as phoneValidate } from 'phone';
import { replace } from 'lodash';
const removeAnySigns = (value: string) => {
  return replace(value, '+', '');
};
export const phoneSchema = z
  .string()
  .min(10)
  .trim()
  .transform((value, ctx) => {
    const saudiNumber = phoneValidate(value, { country: 'SA' });
    if (saudiNumber.phoneNumber && saudiNumber.isValid) {
      const phone = removeAnySigns(saudiNumber.phoneNumber);
      return phone;
    } else {
      const nonSaudi = phoneValidate(value);
      if (nonSaudi.phoneNumber && nonSaudi.isValid) {
        const phone = removeAnySigns(nonSaudi.phoneNumber);
        return phone;
      } else {
        ctx.addIssue({
          code: 'custom',
          message: 'invalid_phone_number',
        });
        return value;
      }
    }
  });
